<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <vendor-field
          slot="pu_vendname"
          :label="customLabel.pu_vendname || '供应商'"
          v-model="form.main.pu_vendname"
          @select="onSelectVendor"
        />
        <combo-field
          slot="pu_shipaddresscode"
          :label="customLabel.pu_shipaddresscode || '交货地址'"
          v-model="form.main.pu_shipaddresscode"
          url="/api/document/address/getCombo"
        />
        <vendor-ct-field
          slot="pu_contact"
          v-model="form.main.pu_contact"
          :label="customLabel.pu_contact || '联系人'"
          :vendor-id="form.main.pu_vendid"
          v-if="form.main.pu_vendname"
        />
        <div class="weui-cell" v-if="form.main.pu_tel" slot="pu_tel">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pu_tel || "联系电话"
            }}</label>
          </div>
          <div class="weui-cell__bd">{{ form.main.pu_tel }}</div>
        </div>
        <payment-field
          slot="pu_payments"
          :label="customLabel.pu_payments || '付款方式'"
          :is-rec="false"
          v-model="form.main.pu_payments"
          @select="onSelectPayment"
          limit="vendor"
          :limit-id="form.main.pu_vendid"
        />
        <currency-field
          slot="pu_currency"
          :label="customLabel.pu_currency || '币种'"
          v-model="form.main.pu_currency"
          @select="onSelectCurrency"
        />
        <div class="weui-cell" slot="pu_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.pu_taxrate || "税率"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.pu_taxrate"
              @change="calcItem('税率')"
              placeholder="请输入"
            />
          </div>
        </div>
        <custom-field
          :label="customLabel.pu_text1 || '自定义字段1'"
          v-model="form.main.pu_text1"
          :caller="caller"
          fieldName="pu_text1"
          slot="pu_text1"
          hidden="true"
        />
        <custom-field
          :label="customLabel.pu_text2 || '自定义字段2'"
          v-model="form.main.pu_text2"
          :caller="caller"
          fieldName="pu_text2"
          slot="pu_text2"
          hidden="true"
        />
        <custom-field
          :label="customLabel.pu_text3 || '自定义字段3'"
          v-model="form.main.pu_text3"
          :caller="caller"
          fieldName="pu_text3"
          slot="pu_text3"
          hidden="true"
        />
        <custom-field
          :label="customLabel.pu_text4 || '自定义字段4'"
          v-model="form.main.pu_text4"
          :caller="caller"
          fieldName="pu_text4"
          slot="pu_text4"
          hidden="true"
        />
        <custom-field
          :label="customLabel.pu_text5 || '自定义字段5'"
          v-model="form.main.pu_text5"
          :caller="caller"
          fieldName="pu_text5"
          slot="pu_text5"
          hidden="true"
        />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <custom-layout
          class="weui-cells"
          :view-config="customViewConfig"
          position="detail1"
        >
          <product-field-order
            slot="pr_detail"
            :label="customLabel.pr_detail || '产品名称'"
            listUrl="/api/purchase/inquiryprice/product_list"
            :extraParams="{
              vendId: form.main.pu_vendid,
              currency: form.main.pu_currency,
            }"
            v-model="item.productDTO.pr_detail"
            @select="onSelectProduct($event, item)"
          />
          <div
            class="weui-cell"
            v-if="item.pd_prodcode"
            slot="pd_prodcode"
            key="pd_prodcode"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_prodcode || "产品编号"
              }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.pd_prodcode }}</div>
          </div>
          <div
            class="weui-cell"
            v-if="item.productDTO.pr_orispeccode"
            slot="pr_orispeccode"
            key="pr_orispeccode"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_orispeccode || "型号"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ item.productDTO.pr_orispeccode }}
            </div>
          </div>
          <div
            class="weui-cell"
            v-if="item.productDTO.pr_spec"
            slot="pr_spec"
            key="pr_spec"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_spec || "规格"
              }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.productDTO.pr_spec }}</div>
          </div>
          <div
            class="weui-cell"
            v-if="item.productDTO.pr_brand"
            slot="pr_brand"
            key="pr_brand"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pr_brand || "厂家/品牌"
              }}</label>
            </div>
            <div class="weui-cell__bd">{{ item.productDTO.pr_brand }}</div>
          </div>
          <div class="weui-cell" slot="pd_qty" key="pd_qty">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_qty || "数量"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_qty"
                @change="calcItem('数量', item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit }}</div>
          </div>
          <div class="weui-cell" v-if="item.productDTO.pr_unit_extra">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{ "辅助数量" }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                :value="
                  $number.round(
                    (item.pd_qty / item.productDTO.pr_denominator) *
                      item.productDTO.pr_numerator || 0,
                    3
                  )
                "
                @input="oninputQty($event, item)"
                placeholder="请填写"
              />
            </div>
            <div class="weui-cell__ft">{{ item.productDTO.pr_unit_extra }}</div>
          </div>
          <div
            class="weui-cell"
            slot="pd_taxprice"
            v-if="priceMethod == '1'"
            key="pd_taxprice"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_taxprice || "不含税单价"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_taxprice"
                @change="calcItem('不含税单价', item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div
            class="weui-cell"
            v-if="item.pd_taxprice && priceMethod == '1'"
            slot="pd_taxtotal"
            key="pd_taxtotal"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_taxtotal || "不含税金额"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ numberFormat(item.pd_taxtotal, "¥#,##0.00") }}
            </div>
          </div>
          <div
            class="weui-cell"
            slot="pd_price"
            v-if="priceMethod == '0'"
            key="pd_price"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_price || "含税单价"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                v-model="item.pd_price"
                @change="calcItem('含税单价', item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div
            class="weui-cell"
            slot="sd_price_extra"
            :hidden="!item.productDTO.pr_unit_extra"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{ "辅助单价" }}</label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="number"
                :value="
                  $number.round(
                    (item.pd_price / item.productDTO.pr_denominator) *
                      item.productDTO.pr_numerator || 0,
                    3
                  )
                "
                @input="oninputPriceExtra($event, item)"
                placeholder="请填写"
              />
            </div>
          </div>
          <div
            class="weui-cell"
            v-if="item.pd_price && priceMethod == '0'"
            slot="pd_total"
            key="pd_total"
          >
            <div class="weui-cell__hd">
              <label for class="weui-label">{{
                customLabel.pd_total || "含税金额"
              }}</label>
            </div>
            <div class="weui-cell__bd">
              {{ numberFormat(item.pd_total, "¥#,##0.00") }}
            </div>
          </div>
          <date-field
            slot="pd_delivery"
            :label="customLabel.pd_delivery || '需求日期'"
            v-model="item.pd_delivery"
          />
          <warehouse-field
            slot="pd_whname"
            v-model="item.pd_whname"
            @select="onSelectWarehouse($event, item)"
            :label="customLabel.pd_whname || '仓库'"
          />
          <employee-field
            :label="customLabel.pd_sellername || '业务员'"
            v-model="item.pd_sellername"
            @select="onSelectEmployee"
            slot="pd_sellername"
          />
          <custom-field
            :label="customLabel.pd_text1 || '自定义字段1'"
            v-model="item.pd_text1"
            :caller="caller"
            fieldName="pd_text1"
            slot="pd_text1"
            hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text2 || '自定义字段2'"
            v-model="item.pd_text2"
            :caller="caller"
            fieldName="pd_text2"
            slot="pd_text2"
            hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text3 || '自定义字段3'"
            v-model="item.pd_text3"
            :caller="caller"
            fieldName="pd_text3"
            slot="pd_text3"
            hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text4 || '自定义字段4'"
            v-model="item.pd_text4"
            :caller="caller"
            fieldName="pd_text4"
            slot="pd_text4"
            hidden="true"
          />
          <custom-field
            :label="customLabel.pd_text5 || '自定义字段5'"
            v-model="item.pd_text5"
            :caller="caller"
            fieldName="pd_text5"
            slot="pd_text5"
            hidden="true"
          />
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </custom-layout>
      </div>
      <div class="weui-cells">
        <file-field v-model="form.main.pu_attach" ref="pu_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import VendorField from "@/components/field/VendorField.vue";
import FileField from "@/components/field/FileField.vue";
import ComboField from "@/components/field/ComboField.vue";
import VendorCtField from "@/components/field/VendorCtField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import ProductFieldOrder from "@/components/field/ProductFieldOrder.vue";
import DateField from "@/components/field/DateField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import WarehouseField from "@/components/field/WarehouseField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";
import Config from "@/util/config";

export default {
  components: {
    CustomLayout,
    VendorField,
    FileField,
    ComboField,
    VendorCtField,
    PaymentField,
    CurrencyField,
    ProductFieldOrder,
    DateField,
    EmployeeField,
    WarehouseField,
    CustomField,
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/purchase/purchase",
      codeField: "pu_code",
      statusField: "pu_statuscode",
      caller: "Purchase",
      xtype: "purchase-purchase-formpanel",
      form: {
        main: {
          pu_vendname: null,
          pu_vendid: null,
          pu_contact: null,
          pu_shipaddresscode: null,
          pu_tel: null,
          pu_payments: null,
          pu_currency: null,
          pu_taxrate: 0,
        },
        items: [
          {
            pd_qty: 0,
            pd_taxprice: 0,
            pd_taxtotal: 0,
            pd_price: 0,
            pd_total: 0,
            pd_taxamount: 0,
            productDTO: {},
          },
        ],
      },
      priceMethod: "0",
    };
  },
  created() {
    this.getData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getData();
    });
  },
  methods: {
    getData() {
      var me = this,
        id = me.$route.query.id;
      if (id) {
        me.f_get(function (data) {
          if (!data.main.pu_shipaddresscode) {
            me.getDefaultAddr();
          }
        }, id);
      } else {
        me.getDefaultAddr();
      }
      Config.getConfigValue("priceMethod").then(
        (v) => (me.priceMethod = v ? v.data : "0")
      );
    },
    /**
     * 选择仓库
     */
    onSelectWarehouse(selection, item) {
      item.pd_whid = selection.id;
      item.pd_whcode = selection.wh_code;
    },
    /**
     * 默认收货地址
     */
    getDefaultAddr() {
      var me = this;
      me.$ajax({
        url: "/api/document/address/getDefault",
      }).then(function (res) {
        if (res.success) {
          me.form.main.pu_shipaddresscode = res.data.ad_address;
        }
      });
    },
    /**
     * 选择供应商
     */
    onSelectVendor(selection) {
      var me = this,
        main = me.form.main;
      main.pu_vendid = selection.id;
      main.pu_vendcode = selection.ve_code;
      main.pu_buyerid = selection.ve_buyerid;
      main.pu_buyercode = selection.ve_buyercode;
      main.pu_buyername = selection.ve_buyername;
      main.pu_currency = selection.ve_currency;
      main.pu_rate = selection.cr_rate;
      main.pu_contact = selection.vc_name;
      main.pu_tel = selection.vc_tel;
      main.pu_paymentsid = selection.ve_paymentsid;
      main.pu_paymentscode = selection.ve_paymentscode;
      main.pu_payments = selection.ve_payments;
      main.pu_taxrate = selection.ve_taxrate;
    },
    /**
     * 选择付款方式
     */
    onSelectPayment(selection) {
      var me = this,
        main = me.form.main;
      main.pu_paymentsid = selection.vp_paid;
      main.pu_paymentscode = selection.vp_pacode;
    },
    /**
     * 选择币种
     */
    onSelectCurrency(selection) {
      var me = this,
        main = me.form.main;
      main.pu_rate = selection.cr_rate;
    },
    /**
     * 选择明细产品
     */
    onSelectProduct(selection, item) {
      item.pd_prodid = selection.id;
      item.pd_prodcode = selection.pr_code;
      item.productDTO = Object.assign({}, selection);

      item.priceList = selection.priceList.reverse();
    },
    /**
     * 输入辅助数量
     */
    oninputQty(e, item) {
      item.pd_qty =
        (e.target.value / item.productDTO.pr_numerator) *
        item.productDTO.pr_denominator;
      this.calcItem("数量", item);
    },
    /**
     * 输入辅助单价
     */
    oninputPriceExtra(e, item) {
      item.pd_price =
        (e.target.value / item.productDTO.pr_numerator) *
        item.productDTO.pr_denominator;
      this.calcItem("含税单价", item);
    },
    /**
     * 计算单价、金额
     */
    calcItem(type, selection) {
      var me = this,
        main = me.form.main,
        tr = main.pu_taxrate || 0,
        items = selection ? [selection] : me.form.items;

      items.forEach((item) => {
        item.pd_qty = me.$number.round(item.pd_qty || 0, 3);

        if (type == "数量") {
          let price;
          if (item.priceList && item.priceList.length > 0) {
            price = item.priceList.find((e) => item.pd_qty >= e.ipd_lapqty);
            item.pd_price = me.$number.round(price.ipd_price || 0, 6);
          }
          item.pd_total = me.$number.round(item.pd_qty * item.pd_price, 2);
          item.pd_taxprice = me.$number.round(
            item.pd_price / (1 + tr / 100),
            6
          );
          item.pd_taxtotal = me.$number.round(
            item.pd_qty * item.pd_taxprice,
            2
          );
        } else if (type == "不含税单价") {
          item.pd_taxprice = me.$number.round(item.pd_taxprice || 0, 6);
          item.pd_taxtotal = me.$number.round(
            item.pd_qty * item.pd_taxprice,
            2
          );
          item.pd_price = me.$number.round(
            item.pd_taxprice * (1 + tr / 100),
            6
          );
          item.pd_total = me.$number.round(item.pd_qty * item.pd_price, 2);
        } else if (type == "含税单价" || type == "税率") {
          item.pd_price = me.$number.round(item.pd_price || 0, 6);
          item.pd_total = me.$number.round(item.pd_qty * item.pd_price, 2);
          item.pd_taxprice = me.$number.round(
            item.pd_price / (1 + tr / 100),
            6
          );
          item.pd_taxtotal = me.$number.round(
            item.pd_qty * item.pd_taxprice,
            2
          );
        }

        item.pd_taxamount = item.pd_total - item.pd_taxtotal;
      });
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.pd_sellerid  = selection.id;
      main.pd_sellercode = selection.em_code;
      main.pd_seller_dpid = selection.em_dpid;
      main.pd_seller_dpname = selection.dp_name;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.pu_vendname) {
        me.$weui.topTips("请选择供应商", 2000);
      } else if (!main.pu_payments) {
        me.$weui.topTips("请选择付款方式", 2000);
      } else if (!main.pu_currency) {
        me.$weui.topTips("请选择币种", 2000);
      } else {
        main.pu_taxrate = main.pu_taxrate || 0;
        var count = 0,
          total = 0,
          nettotal = 0,
          tax = 0;
        items.forEach(function (item) {
          if (!item.pd_prodid) {
            me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
            return false;
          } else if (!item.pd_qty || item.pd_qty <= 0) {
            me.$weui.topTips(`第${count + 1}行数量未填写`, 2000);
            return false;
          } else {
            count++;
            item.pd_detno = count;
            item.pd_taxrate = main.pu_taxrate;
            // 合计
            total += item.pd_total;
            nettotal += item.pd_taxtotal;
            tax += item.pd_taxamount;
          }
        });
        checked = count == items.length;
        main.pu_total = total;
        main.pu_taxtotal = nettotal;
        main.pu_taxamount = tax;
      }

      if (checked) {
        me.p_save();
      }
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        pd_qty: 0,
        pd_taxprice: 0,
        pd_taxtotal: 0,
        pd_price: 0,
        pd_total: 0,
        pd_taxamount: 0,
        productDTO: {},
      });
    },
  },
};
</script>